import React from 'react';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { Loader2, CheckCircle2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

/**
 * Reusable modal for showing upload progress
 * Used for Gates 1, 2, 4, 5 (auto-processing gates)
 */
const UploadProgressModal = ({ 
  isOpen, 
  title, 
  message, 
  isComplete = false, 
  onContinue,
  showSpinner = true,
  error = null
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={() => {}}>
      <DialogContent 
        className="sm:max-w-md bg-slate-900 border-slate-700 text-white"
        hideCloseButton={!isComplete}
      >
        <div className="text-center p-6">
          {error ? (
            <>
              <div className="text-red-500 text-6xl mb-4">⚠️</div>
              <h3 className="text-xl font-semibold mb-3 text-white">{title}</h3>
              <p className="text-red-400 mb-4">{error}</p>
              {onContinue && (
                <Button 
                  onClick={onContinue}
                  variant="outline"
                  className="w-full border-slate-600 text-slate-300 hover:bg-slate-800"
                  data-testid="upload-progress-retry-btn"
                >
                  Try Again
                </Button>
              )}
            </>
          ) : !isComplete ? (
            <>
              {showSpinner && (
                <Loader2 className="w-16 h-16 text-blue-500 mx-auto mb-4 animate-spin" />
              )}
              <h3 className="text-xl font-semibold mb-3 text-white">{title}</h3>
              <p className="text-slate-400">{message}</p>
            </>
          ) : (
            <>
              <CheckCircle2 className="w-16 h-16 text-green-500 mx-auto mb-4" />
              <h3 className="text-xl font-semibold mb-4 text-white">Complete!</h3>
              {onContinue && (
                <Button 
                  onClick={onContinue}
                  className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-6 rounded-lg transition-colors"
                  data-testid="upload-progress-continue-btn"
                >
                  Continue
                </Button>
              )}
            </>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default UploadProgressModal;
